import { Injectable } from '@angular/core';
import { EnvironmentConfig } from '@src/app/configs/environment.config';

@Injectable({
  providedIn: 'root',
})
export class AssetServiceConfig {
  public backendUrl = ''; // ie. 'http://localhost:9000';
}

export function createAssetServiceConfig(env?: EnvironmentConfig): AssetServiceConfig {
  const config = new AssetServiceConfig();

  if (env) {
    if (env.backendUrl) {
      config.backendUrl = env.backendUrl;
    }
  }

  return config;
}
